var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Grid, Select } from "semantic-ui-react";
var ChangeVariantValidationModal = /** @class */ (function (_super) {
    __extends(ChangeVariantValidationModal, _super);
    function ChangeVariantValidationModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onValidationChange = function (event, data) {
            _this.setState({
                validationType: data.value
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) + "/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString()) + "/variants/id/" + encodeURIComponent(_this.props.variant.id.toString()) + "/validate", {
                validate: _this.state.validationType
            });
        };
        _this.state = {
            validationType: _this.props.validationType
        };
        return _this;
    }
    ChangeVariantValidationModal.prototype.render = function () {
        return React.createElement(Grid, { columns: 1, centered: true },
            React.createElement(Grid.Row, null,
                React.createElement("p", null,
                    "Are you sure you want to change the validation status for variant ",
                    this.props.variant.name)),
            React.createElement(Grid.Row, null,
                React.createElement(Select, { options: this.props.validationTypes.map(function (vt) { return ({ text: vt, value: vt }); }), onChange: this.onValidationChange, value: this.state.validationType })),
            React.createElement(Grid.Row, null,
                React.createElement(Button, { label: "Change validation status", labelPosition: 'left', onClick: this.submit, icon: 'exchange' })));
    };
    return ChangeVariantValidationModal;
}(React.PureComponent));
export default ChangeVariantValidationModal;
//# sourceMappingURL=ChangeVariantValidationModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeVariantValidationModal.js
// module id = 1462
// module chunks = 0